export const AUTH_TOKEN_KEY = "authToken";
export const SESSION_EXPIRED_KEY = "authSessionExpired";

const PROTECTED_PATH_PREFIXES = [
  "/adminPanel",
  "/editCourse",
  "/editTeacher",
  "/registeredUsers",
  "/certificates",
  "/addImage",
  "/addTeacher",
  "/addTeacherToCourse",
];

export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);

export const setAuthToken = (token) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const clearAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
};

export const markSessionExpired = () => {
  sessionStorage.setItem(SESSION_EXPIRED_KEY, "1");
};

export const consumeSessionExpiredFlag = () => {
  const value = sessionStorage.getItem(SESSION_EXPIRED_KEY);
  if (value) {
    sessionStorage.removeItem(SESSION_EXPIRED_KEY);
  }
  return Boolean(value);
};

export const isProtectedPath = (pathname = window.location.pathname) =>
  PROTECTED_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

export const redirectToLogin = () => {
  if (window.location.pathname === "/login") {
    return;
  }
  window.location.assign("/login");
};

/**
 * Clears expired auth and either sends the user to login (admin pages)
 * or lets public pages continue without a token.
 */
export const handleUnauthorized = ({ isLoginRequest = false } = {}) => {
  if (isLoginRequest) {
    return { shouldRetryWithoutToken: false, redirected: false };
  }

  const hadToken = Boolean(getAuthToken());
  clearAuthToken();

  if (!hadToken) {
    return { shouldRetryWithoutToken: false, redirected: false };
  }

  markSessionExpired();

  if (isProtectedPath()) {
    redirectToLogin();
    return { shouldRetryWithoutToken: false, redirected: true };
  }

  // Public page: drop bad token and retry the request without Authorization
  return { shouldRetryWithoutToken: true, redirected: false };
};
